import React from 'react';
var FormContext = /*#__PURE__*/React.createContext({
  controlId: undefined
});
export default FormContext;